import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'
import { type IconId } from '@stone-payments/jade'

export type MarketInvestmentBanner = {
  icon: IconId
  title: string
  tralling: string
  description: string
}

export type HomeExperimentPayload = {
  market_investment: {
    market_investment_banner: Partial<MarketInvestmentBanner>
  }
}

const defaultMarketInvestmentBanner: MarketInvestmentBanner = {
  icon: 'chart-arrow-up',
  title: 'Mais rentabilidade',
  tralling: 'Conhecer',
  description: 'Outras opções com rendimentos superiores.'
}

export const defaultHomeExperimentPayload: ExperimentValue<HomeExperimentPayload> = {
  value: 'control',
  payload: {
    market_investment: {
      market_investment_banner: defaultMarketInvestmentBanner
    }
  }
}
